import React from 'react'
import {
  Card,
} from './index'
import { Link } from 'react-router-dom'
// import { CardBig } from './card-big'
import PropTypes from 'prop-types'

const List = ({data, uniform, embed, bookmark}) => {
  const width = embed ? 'w-1/2 lg:w-1/3' : 'w-1/2'

  return (
    <div>
      <div className="flex flex-wrap -mx-2 lg:-mx-4">
        {
          data && data.map((d, index) => {
            if (index > 0) {
              return (
                <div className={`${width} px-2 lg:px-4 mb-5 lg:mb-8`} key={index}>
                  <Link to={`/event/detail/${d.id}`}>
                    <Card data={d} embed={embed} bookmark={bookmark}/>
                  </Link>
                </div>
              )
            }

            return uniform ? (
              <div className={`${width} px-2 lg:px-4 mb-5 lg:mb-8`} key={index}>
                <Link to={`/event/detail/${d.id}`}>
                  <Card data={d} embed={embed} bookmark={bookmark}/>
                </Link>
              </div>
            ) : (
              <div className={`w-full_bak ${width} px-2 lg:px-4 mb-5 lg:mb-8`} key={index}>
                <Link to={`/event/detail/${d.id}`}>
                  {/* Big card ganti jadi featured */}
                  {/* <CardBig data={d} embed={embed} bookmark={bookmark}/> */}

                  <Card data={d} embed={embed} bookmark={bookmark}/>
                </Link>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

List.propTypes = {
  data: PropTypes.array,
  uniform: PropTypes.bool,
  embed: PropTypes.bool,
  bookmark: PropTypes.bool,
}

List.defaultProps = {
  data: [],
  uniform: false,
  embed: false,
  bookmark: false,
}

export { List }